import { render, staticRenderFns } from "./copeModelDialog.vue?vue&type=template&id=f547bc48&scoped=true&lang=pug"
import script from "./copeModelDialog.vue?vue&type=script&lang=js"
export * from "./copeModelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547bc48",
  null
  
)

export default component.exports